import React, { useState } from "react";
import "../styles.css";

const Spoiler = ({ children }) => {
  const [revealed, setRevealed] = useState(false);

  return (
    <span
      className={`spoiler${revealed ? " revealed" : ""}`}
      onClick={() => setRevealed(true)}
      role="button"
      aria-label={revealed ? "Spoiler odhalen" : "Klikni pro odhalení spoileru"}
    >
      {children}
    </span>
  );
};

export default Spoiler;
